import Cookies from 'js-cookie';

export const stringToBase64 = (str: string) => {
  return window.btoa(unescape(encodeURIComponent(str)));
};

export const base64ToString = (str: string) => {
  return window.atob(str);
};

export const numberValidation = (data: string) => {
  if (/\D/.test(data)) {
    return 'کد امنیتی را به درستی وارد کنید.';
  }
  return true;
};

export const capitalize = (str: string) => {
  str = String(str);
  return str.charAt(0).toUpperCase() + str.slice(1);
};

export const getDomain = () => {
  const hostname = window.location.hostname;
  const hostnameArray = hostname.split('.');
  const numberOfSubdomains = hostnameArray.length - 2;
  if (hostnameArray.length === 2) {
    return '.' + hostname;
  }
  return '.' + hostnameArray.slice(numberOfSubdomains).join('.');
};

export const genarateNumber = () => {
  return Math.floor(Math.random() * 1000);
};

export const phoneNumberWithStar = (num: string | number) => {
  let phone = String(num);
  let slicePhone = phone.slice(4, 8);
  let replaceStar = phone.replaceAll(slicePhone, '****');
  return replaceStar;
};

export const acceptNumberRegex = (src: string) => {
  return src.replace(/[^0-9.]/g, '');
};

export const setCookies = (token: string) => {
  const optionsDev = {
    expires: 720,
    path: '/',
  };
  const optionsPro = {
    expires: 720,
    path: '/',
    domain: getDomain(),
    secure: true,
    sameSite: 'Lax',
  };
  const options =
    window.api?.APP_ENV === 'production' ? optionsPro : optionsDev;

  Cookies.set('client_id', token, options);
};

export const calcExpireDate = (ExpireDate: number | undefined) => {
  if (!ExpireDate)
    return {
      minutes: 0,
      seconds: 0,
    };
  let minutes = Math.floor(ExpireDate / 60);
  let seconds = ExpireDate - minutes * 60;
  return {
    minutes,
    seconds,
  };
};

export const handleProductType = (searchParams: URLSearchParams) => {
  return capitalize(searchParams.get('pt') || window.api?.APP_TYPE || 'Trader');
};

export const getCookies = () => {
  const client_id = Cookies.get('client_id');
  return client_id ? client_id : '';
};

export const lastChar = (str: string) => {
  return str.charAt(str.length - 1);
};

export const toEnglishNumber = (str: string): string => {
  const persianNumbers = [
    /۰/g,
    /۱/g,
    /۲/g,
    /۳/g,
    /۴/g,
    /۵/g,
    /۶/g,
    /۷/g,
    /۸/g,
    /۹/g,
  ];
  const arabicNumbers = [
    /٠/g,
    /١/g,
    /٢/g,
    /٣/g,
    /٤/g,
    /٥/g,
    /٦/g,
    /٧/g,
    /٨/g,
    /٩/g,
  ];

  for (let i = 0; i < 10; i++) {
    str = str
      .replace(persianNumbers[i], String(i))
      .replace(arabicNumbers[i], String(i));
  }

  return str;
};

export const getUniqId = () => (Math.random() + 1).toString(36).substring(2);

//////////////////////////////////////////////////////fingerprint helper

const hashAlgorithms = [
  { key: 'AES-CCM-64-128-256', value: 33 },
  { key: 'AES-CCM-64-128-128', value: 32 },
  { key: 'AES-CCM-16-128-256', value: 31 },
  { key: 'AES-CCM-16-128-128', value: 30 },
  { key: 'AES-MAC 256/128', value: 26 },
  { key: 'AES-MAC 128/128', value: 25 },
  { key: 'ChaCha20/Poly1305', value: 24 },
  { key: 'AES-MAC 256/64', value: 15 },
  { key: 'AES-MAC 128/64', value: 14 },
  { key: 'AES-CCM-64-64-256', value: 13 },
  { key: 'AES-CCM-64-64-128', value: 12 },
  { key: 'AES-CCM-16-64-256', value: 11 },
  { key: 'AES-CCM-16-64-128', value: 10 },
  { key: 'HMAC 512/512', value: 7 },
  { key: 'HMAC 384/384', value: 6 },
  { key: 'HMAC 256/256', value: 5 },
  { key: 'HMAC 256/64', value: 4 },
  { key: 'A256GCM', value: 3 },
  { key: 'A192GCM', value: 2 },
  { key: 'A128GCM', value: 1 },
  { key: 'A128KW', value: -3 },
  { key: 'A192KW', value: -4 },
  { key: 'A256KW', value: -5 },
  { key: 'direct', value: -6 },
  { key: 'ES256', value: -7 },
  { key: 'EdDSA', value: -8 },
  { key: 'direct+HKDF-SHA-256', value: -10 },
  { key: 'direct+HKDF-SHA-512', value: -11 },
  { key: 'direct+HKDF-AES-128', value: -12 },
  { key: 'direct+HKDF-AES-256', value: -13 },
  { key: 'SHA-256', value: -16 },
  { key: 'SHA-512/256', value: -17 },
  { key: 'SHAKE128', value: -18 },
  { key: 'ECDH-ES + HKDF-256', value: -25 },
  { key: 'ECDH-ES + HKDF-512', value: -26 },
  { key: 'ECDH-SS + HKDF-256', value: -27 },
  { key: 'ECDH-SS + HKDF-512', value: -28 },
  { key: 'ECDH-ES + A128KW', value: -29 },
  { key: 'ECDH-ES + A192KW', value: -30 },
  { key: 'ECDH-ES + A256KW', value: -31 },
  { key: 'ECDH-SS + A128KW', value: -32 },
  { key: 'ECDH-SS + A192KW', value: -33 },
  { key: 'ECDH-SS + A256KW', value: -34 },
  { key: 'ES384', value: -35 },
  { key: 'ES512', value: -36 },
  { key: 'PS256', value: -37 },
  { key: 'PS384', value: -38 },
  { key: 'PS512', value: -39 },
  { key: 'RSAES-OAEP w/ RFC 8017 default parameters', value: -40 },
  { key: 'RSAES-OAEP w/ SHA-256', value: -41 },
  { key: 'RSAES-OAEP w/ SHA-512', value: -42 },
  { key: 'SHA-384', value: -43 },
  { key: 'SHA-512', value: -44 },
  { key: 'SHAKE256', value: -45 },
  { key: 'HSS-LMS', value: -46 },
  { key: 'IV-GENERATION', value: 34 },
  { key: 'ES256K', value: -47 },
  { key: 'RS256', value: -257 },
  { key: 'RS384', value: -258 },
  { key: 'RS512', value: -259 },
  { key: 'WalnutDSA', value: -260 },
  { key: 'SHA-1', value: -14 },
  { key: 'SHA-256/64', value: -15 },
  { key: 'RS1', value: -65535 },
  { key: 'Reserved for Private Use', value: -65536 },
];

export const strToHashAlgorithm = (item: number) =>
  hashAlgorithms.filter((alg) => String(alg.key) === String(item))[0]?.value;

export const getPubkeyParams = (
  arrayParams: PublicKeyCredentialParameters[]
) => {
  var coseArrayParams: PublicKeyCredentialParameters[] = [];
  arrayParams.forEach((arrayParam) => {
    coseArrayParams.push({
      type: 'public-key',
      alg: strToHashAlgorithm(arrayParam.alg),
    });
  });

  return coseArrayParams;
};

export const stringToArrayBuffer = (value: string): Uint8Array =>
  new TextEncoder().encode(value);

const chars =
  'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';

// Use a lookup table to find the index.
const lookup = new Uint8Array(256);
for (let i = 0; i < chars.length; i++) {
  lookup[chars.charCodeAt(i)] = i;
}

const encode = (arraybuffer: any) => {
  const bytes = new Uint8Array(arraybuffer);
  const len = bytes.length;
  let base64 = '';

  for (let i = 0; i < len; i += 3) {
    base64 += chars[bytes[i] >> 2];
    base64 += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
    base64 += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
    base64 += chars[bytes[i + 2] & 63];
  }

  if (len % 3 === 2) {
    base64 = base64.substring(0, base64.length - 1);
  } else if (len % 3 === 1) {
    base64 = base64.substring(0, base64.length - 2);
  }

  return base64;
};

const decode = (base64 : any) => {
  const len = base64.length;
  const bufferLength = base64.length * 0.75;
  const arraybuffer = new ArrayBuffer(bufferLength);
  const bytes = new Uint8Array(arraybuffer);

  let p = 0;
  for (let i = 0; i < len; i += 4) {
    const encoded1 = lookup[base64.charCodeAt(i)];
    const encoded2 = lookup[base64.charCodeAt(i + 1)];
    const encoded3 = lookup[base64.charCodeAt(i + 2)];
    const encoded4 = lookup[base64.charCodeAt(i + 3)];

    bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
    bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
    bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
  }

  return arraybuffer;
};

export const base64url = { encode, decode };
